<template>
  <div class="all-menu">
    <div
      v-for="(navChoice, index) in navChoices"
      :key="index"
      class="component"
      :style="'width : ' + 100 / navChoices.length + '%'"
      :class="{ active: navChoice.active, left: index === 0, right: index === navChoices.length - 1 }"
      @click="setNavChoice(index)"
    >
      <div class="text">
        {{ navChoice.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'styled-plaintext',
  props: {
    navChoices: Array,
    name: {
      type: String,
      default: 'default',
    },
  },

  mounted() {
    if (this.$route.query[`menu-${this.name}`]) {
      this.$emit('input', this.$route.query[`menu-${this.name}`])
      const navIndex = this.navChoices.findIndex(
        (navChoice) => navChoice.link === this.$route.query[`menu-${this.name}`],
      )
      this.navChoices[navIndex].active = true
    } else {
      this.navChoices[0].active = true
      this.$emit('input', this.navChoices[0].link)
    }
  },

  methods: {
    setNavChoice(index) {
      for (let i = 0; i < this.navChoices.length; i++) {
        if (this.navChoices[i].active === true) {
          this.navChoices[i].active = false
        }
      }
      this.navChoices[index].active = true
      const query = { ...this.$route.query }
      query[`menu-${this.name}`] = this.navChoices[index].link
      this.$router.replace({ query })
      this.$emit('input', this.navChoices[index].link)
    },
  },
}
</script>

<style lang="scss"></style>
